const formats = [
    "bold", "code", "strike", "script", "underline",
    "header", "indent", "list", "code-block"
];

export default formats;
